import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonGroup, Modal} from '@veneer/core';

import {useTenantContext} from '@br/idm-components';

const RemovePartner = ({
    onRemovePartner,
    partnerName,
}: {
    onRemovePartner: () => void;
    partnerName: string;
}): JSX.Element => {
    const {t} = useTranslation(['settings']);
    const {tenant} = useTenantContext();

    const [showModal, setShowModal] = useState(false);
    const handleShowModal = useCallback(() => setShowModal(true), []);
    const onClose = useCallback(() => {
        setShowModal(false);
    }, []);
    const handleRemovePartner = useCallback(() => {
        onRemovePartner();
        onClose();
    }, [onRemovePartner, onClose]);

    return (
        <>
            <Button
                style={{height: '48px'}}
                appearance="secondary"
                className="ms-5"
                onClick={handleShowModal}
            >
                {t('settings:removePartner', 'Remove partner')}
            </Button>
            <Modal
                id="remove-partner-modal"
                onClose={onClose}
                show={showModal}
                title={t('settings:removePartner', 'Remove partner')}
                footer={
                    <ButtonGroup>
                        <Button
                            appearance="primary"
                            onClick={handleRemovePartner}
                        >
                            {t('settings:removePartner', 'Remove partner')}
                        </Button>
                        <Button
                            appearance="secondary"
                            onClick={onClose}
                        >
                            {t('settings:cancel', 'Cancel')}
                        </Button>
                    </ButtonGroup>
                }
            >
                <p className="pb-2">
                    {t(
                        'settings:removePartnerDescription',
                        'Are you sure you want to remove the partner "{{partner}}" from the tenant "{{tenant}}"?',
                        {partner: partnerName, tenant: tenant.name}
                    )}
                </p>
            </Modal>
        </>
    );
};

export default RemovePartner;
